import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    document.querySelector('body').insertAdjacentHTML('beforeEnd', this.modalTemplate());

		$(document).on('click', '[data-action^="student-attendance-cancel"]', (ev) => {
			ev.preventDefault();
			this[ev.currentTarget.dataset.action.replace('student-attendance-cancel#', '')](ev);
		});
	}

	requestCredit(ev) {
		let dataset = ev.currentTarget.dataset;

		this.formTarget.setAttribute('action', dataset.urlPath);
		this.openModal();
	}

	openModal() {
		$(this.modalTarget).modal('show');
	}

	modalTemplate() {
		return `
			<div class="modal fade" tabindex="-1" role="dialog" id="student-attendance-cancel-modal">
				<div class="modal-dialog modal-md" role="document">
					<div class="modal-content">
						<form action="" role="form" method="post" class="tr-form" enctype="multipart/form-data" id="student-attendance-cancel-form">
							<div class="modal-header justify-content-between align-items-start">
								<h5 class="modal-title">Cancelamento de Aula</h5>
								<button type="button" class="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div class="modal-body">
								<p>Solicite a reposição como crédito somente quando você sabe que não poderá vir na aula mas não tem certeza de quando poderá repor e
									por esse motivo gostaria de deixar essa aula como crédito e repor em outra oportunidade</p>

								<div class="form-group mb-0">
									<label>Comentário</label>
									<textarea name="comment" id="text-observation" cols="30" rows="5" class="form-control" data-student-attendance-cancel-target="commentTextarea"></textarea>
								</div>

								<div class="my-4">
									<span class="d-flex justify-content-start align-items-center">
										<i class="fas fa-paperclip font-grey-silver mr-2"></i> <input type="file" name="attachments" multiple="multiple" />
									</span>
								</div>
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-gray-primary" data-dismiss="modal">Fechar</button>
								<button type="submit" class="btn btn-purple">Cancelar Aula</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		`;
	}

	get formTarget() {
		return document.querySelector('#student-attendance-cancel-form')
	}

	get modalTarget() {
		return document.querySelector('#student-attendance-cancel-modal')
	}
}